module.exports = __webpack_public_path__ + "img/island-hopping-full-black.bf347ced.svg";